import { render, staticRenderFns } from "./relocationRecord.vue?vue&type=template&id=01b1f7dc&scoped=true&"
import script from "./relocationRecord.vue?vue&type=script&lang=js&"
export * from "./relocationRecord.vue?vue&type=script&lang=js&"
import style0 from "./relocationRecord.vue?vue&type=style&index=0&id=01b1f7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1f7dc",
  null
  
)

export default component.exports